<span [class.condense]="condense" [matTooltip]="tooltip" class="status-container">
  <mat-icon [color]="iconColor()" [ngClass]="status" class="small-icon">traffic</mat-icon>
  <ng-container *ngIf="!condense">{{ status }}</ng-container>
</span>
